<template>
    <div ref="customerPopup" :style="popupStyles"  class="calendar__popup d-calendar__b-popup" v-if="access !== 'doctor' && cell.showPopup">
        <calendar-popup-body :cell="cell"></calendar-popup-body>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

	import CalendarPopupBody from "../CalendarPopupBody.vue";

    export default {
		components: {CalendarPopupBody},
		name: 'CalendarPopup',
        props: {
            cell: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                position: {
                    left: 0,
                    top: 0
                },
                gap: 2,
                leftOffset: 0,
                topOffset: 0
            }
        },
        computed: {
            ...mapState([
                'access',
                'windowWidth'
            ]),
            popupStyles() {
                return {
                    '--uidCalendarPopupAxisY': this.position.top + 'px',
                    '--uidCalendarPopupAxisX': this.position.left ? this.position.left + 'px' : '',
                    '--uidCalendarGap': this.gap + 'px'
                }
            }
        },
        watch: {
            topOffset(offset) {
                if (offset >= document.documentElement.offsetHeight) {
                    this.position.top = -this.$el.clientHeight + this.$parent.$el.clientHeight * 3.125;
                }
            },
            leftOffset(offset) {
                if (offset >= this.windowWidth) {
                    this.position.left = -this.$el.clientWidth + this.$parent.$el.clientWidth + this.gap;
                }
            }
        },
        mounted() {
            this.setPopupPosition();
        },
        methods: {
            setPopupPosition() {
                this.leftOffset = this.$el.getBoundingClientRect().x + this.$el.clientWidth;
                this.topOffset =  (this.$el.getBoundingClientRect().y + window.pageYOffset) + this.$el.clientHeight * 1.25;
            }
        }
    }
</script>
